import React from 'react'

// The camera-off stand-in for the local video. Two-tone on purpose: the camera
// itself inherits currentColor, while the sparkles are addressed separately
// through `.camera-off__sparkle` so the surrounding style can tint them.
export default function CameraSparkle({ className, style }) {
  return (
    <svg className={className} width="1em" height="1em" style={{ verticalAlign: '-0.125em', ...style }} viewBox="0 0 32 32" fill="none"
      stroke="currentColor" strokeWidth="1.5"
      strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.7 11.6a1.8 1.8 0 0 1 1.58.94l.44.81a1.8 1.8 0 0 0 1.58.94h1.7A1.8 1.8 0 0 1 24.8 16.1v7.6a1.8 1.8 0 0 1-1.8 1.8H9a1.8 1.8 0 0 1-1.8-1.8v-7.6a1.8 1.8 0 0 1 1.8-1.81h1.7a1.8 1.8 0 0 0 1.58-.94l.44-.81a1.8 1.8 0 0 1 1.58-.94z" />
      <circle cx="16" cy="19.9" r="2.9" />
      <g className="camera-off__sparkle" stroke="none" fill="currentColor">
        <path d="M9.4 3.2 10.3 5.9 13 6.8 10.3 7.7 9.4 10.4 8.5 7.7 5.8 6.8 8.5 5.9Z" />
        <path d="M14.8 7.8 15.3 9.2 16.7 9.7 15.3 10.2 14.8 11.6 14.3 10.2 12.9 9.7 14.3 9.2Z" />
        <path d="M5.3 10.1 5.7 11.2 6.8 11.6 5.7 12 5.3 13.1 4.9 12 3.8 11.6 4.9 11.2Z" />
      </g>
    </svg>
  )
}
